import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ValidationGuard implements CanActivate {
  constructor(
    private router: Router,
    private location: Location
    ) { }

  canActivate(): boolean {
    const currentNavigation = this.router.getCurrentNavigation();
    const isValidationAllowed = currentNavigation.extras.state?.isValidationAllowed;

    if (!isValidationAllowed) {
      this.location.back();
      return false;
    }

    return true;
  }

}
